import { render, staticRenderFns } from "./menuView.vue?vue&type=template&id=cf95d6d8&scoped=true&"
import script from "./menuView.vue?vue&type=script&lang=js&"
export * from "./menuView.vue?vue&type=script&lang=js&"
import style0 from "./menuView.vue?vue&type=style&index=0&id=cf95d6d8&lang=less&scoped=true&"
import style1 from "./menuView.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf95d6d8",
  null
  
)

export default component.exports